<template>
  <Dialog v-model="dialog" fullscreen :show-close="false">
    <template #title>
      <div class="mt-4 mt-md-8">
        <v-row align="center" justify="space-between">
          <Logo />
          <LanguageSwitcher />
        </v-row>
      </div>
    </template>
    <template #text>
      <InfoMessage
        :title="$t('unavailableClinics.title')"
        :perex="$t('unavailableClinics.description')"
        icon="gears"
        width="480"
        class="mx-auto"
        :show-close="false"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'UnavailableClinics',
  data() {
    return {
      dialog: false
    };
  },
  mounted() {
    //TODO remove comment when BE finish https://ulekare.atlassian.net/browse/DEVUL-4054
    //this.checkClinics()
  },
  methods: {
    checkClinics() {
      this.$http
        .get(
          import.meta.env.VITE_BASE_API_URL.slice(0, import.meta.env.VITE_BASE_API_URL.length - 3)
        )
        .then(() => {
          this.dialog = false;
          setTimeout(this.checkClinics, 15000);
        })
        .catch(err => {
          this.dialog = true;
          this.handleError({ error: err, showModal: false, code: '0x0000000E' });
          setTimeout(this.checkClinics, 5000);
        });
    }
  }
};
</script>
